(function () {
    'use strict';

    angular
        .module('ib-booking-name')
        .service('BookingNameService', BookingNameService);

    BookingNameService.$inject = ['MmBModalService'];
    function BookingNameService(MmBModalService) {

        /**
         * @function
         * @name check
         * @desc opens a modal to ask the passenger
         */
        this.checkName = function (surname, flowId) {
            let passengerInfo={
                surname,
                flowId
            }
             MmBModalService.showBookingNameModal(passengerInfo).result.then(angular.noop, angular.noop);     
        }
    }
})();